import { SxProps, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { isUndefined } from 'lodash-es';

const PROGRESS_BAR_WIDTH_IN_PX = 72;

interface SummaryProps {
  count?: number;
  description: string;
  descriptionSx?: SxProps;
  label?: string;
  total?: number;
}

export function Summary({
  count,
  description,
  descriptionSx,
  label,
  total,
}: SummaryProps) {
  const theme = useTheme();
  const hasProgressIndicator = !isUndefined(count) && !isUndefined(total);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mb: 0.5,
        minWidth: PROGRESS_BAR_WIDTH_IN_PX,
      }}
    >
      {label && (
        <Typography
          sx={{
            color: theme.brandV2.colors.treadGray2,
            fontSize: '12px',
            whiteSpace: 'nowrap',
          }}
        >
          {label}
        </Typography>
      )}
      <Typography
        variant="subtitle2"
        sx={{
          color: theme.brandV2.colors.treadBlack,
          mb: 1,
          whiteSpace: 'nowrap',
          ...descriptionSx,
        }}
      >
        {description}
      </Typography>
      {hasProgressIndicator && (
        <Box
          sx={{
            bgcolor: theme.brandV2.colors.treadGray7,
            borderRadius: '2px',
            height: '4px',
            overflow: 'hidden',
            position: 'relative',
            width: PROGRESS_BAR_WIDTH_IN_PX,

            '&:before': {
              backgroundColor: theme.brandV2.colors.treadBlue,
              bottom: 0,
              content: "''",
              left: 0,
              position: 'absolute',
              top: 0,
              width: `calc((${count} / ${total}) *  100%)`,
            },
          }}
        />
      )}
    </Box>
  );
}
